var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiskey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DE2F45;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E27F08;}\n\t.st3{opacity:0.47;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,183.78c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,149.49,62.06,183.78,104.75,183.78"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "136.61,146.25 142.92,76 67.19,76 72.95,146.25  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "131.53,140.34 77.93,140.34 75.25,112.33 134.58,112.41  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.17,
    y: 121.55,
    transform: "matrix(0.9802 -0.198 0.198 0.9802 -23.8736 19.7602)",
    className: "st3",
    width: 15.39,
    height: 15.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.01,
    y: 121.06,
    transform: "matrix(0.8882 0.4594 -0.4594 0.8882 71.3026 -35.5484)",
    className: "st3",
    width: 15.39,
    height: 15.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.62,
    y: 104.77,
    transform: "matrix(0.9745 -0.2243 0.2243 0.9745 -22.1056 30.2946)",
    className: "st3",
    width: 15.39,
    height: 15.39
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiskey);
export default __webpack_public_path__ + "static/media/Whiskey.3e27a29a6798f8b5699774fd2bc4542d.svg";
export { ForwardRef as ReactComponent };